import { render, staticRenderFns } from "./DataSubscriptionPage.vue?vue&type=template&id=437e2378&scoped=true"
import script from "./DataSubscriptionPage.vue?vue&type=script&lang=js"
export * from "./DataSubscriptionPage.vue?vue&type=script&lang=js"
import style0 from "./DataSubscriptionPage.vue?vue&type=style&index=0&id=437e2378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437e2378",
  null
  
)

export default component.exports